import './App.css';

import React, { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faQuestion, faTowerBroadcast, faMagnifyingGlass, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { createSessionStorage, Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import FormData from "form-data"; // form-data v4.0.1
import Mailgun from "mailgun.js"; // mailgun.js v11.1.0

import 'bootstrap/dist/css/bootstrap.min.css';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function App() {
  // const [code, setCode] = useState();
  const [preliminaryUserEmail, setpreliminaryUserEmail] = useState();
  const [userEmail, setuserEmail] = useState(localStorage.getItem("useremail"));
  const [categories, setcategories] = useState([]);
  const [numCompleted, setnumCompleted] = useState(localStorage.getItem("numcomplete") ? parseInt(localStorage.getItem("numcomplete")) : 0);

  const [item, setItem] = useState(null);

  const [showCreateProfileModal, setshowCreateProfileModal] = useState(false);

  const numCases = 50;


  useEffect(() => {
    if (userEmail) {
      // Get profile
      fetch(`https://sixhats-backend.onrender.com/physician/` + userEmail, {
        method: "get",
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      }).then(result => {
        result.json().then(response => {
          // get categories
          fetch(`https://sixhats-backend.onrender.com/specialty/` + response.specialty + `/prompt_categories`, {
            method: "get",
            headers: {
              "Content-type": "application/json; charset=UTF-8"
            }
          }).then(response2 => {
            response2.json().then(responseDataCategories => {
              setcategories(responseDataCategories.prompt_categories)
            }
            )
          })

        })

      })
    }
  }, []);

  // async function sendSimpleMessage(myCode) {
  //   const mailgun = new Mailgun(FormData);
  //   const mg = mailgun.client({
  //     username: "api",
  //     key:  "api send key here"

  //     // When you have an EU-domain, you must specify the endpoint:
  //     // url: "https://api.eu.mailgun.net"
  //   });
  //   try {
  //     const data = await mg.messages.create("domain", {
  //       from: "Mailgun Sandbox <postmaster@domail>",
  //       to: ["William Engdahl <will@6hats.ai>"],
  //       subject: "6hats Case Study Verification Code",
  //       text: "Please return to the 6hats case study verification site and enter the following code: "+ myCode,
  //     });

  //     console.log(data); // logs response data
  //   } catch (error) {
  //     console.log(error); //logs any error
  //   }
  // }

  const beginSession = async function (event) {
    event.preventDefault();
    let email = prompt("Please enter your email");

    if (email) {
      // let code = Math.floor(Math.random() * 99999);
      // setCode(code.toString())
      // sendSimpleMessage(code)
      setpreliminaryUserEmail(email)
      setshowCreateProfileModal(true)
    }
  }

  const getNewCase = function () {
    let num = Math.floor(Math.random() * categories.length);

    console.log("Selected " + num + " category: " + categories[num])

    fetch(`https://sixhats-backend.onrender.com/case?symptom_category=` + categories[num], {
      method: "get",
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      }
    }).then(response => {
      response.json().then(data => {
        setItem(data)
      }
      )
    })
  }

  useEffect(() => {
    if (categories.length == 0)
      return;
    getNewCase()
  }, [categories]); // Ensure to re-run if loggedInEmail changes

  const saveProfile = async function (event) {
    // Placeholder
    if(document.getElementById("codeCheck").value!="1234"){
      alert("Enter the verification code emailed to you");
      return;
    }

    if (document.getElementById("firstName").value &&
      document.getElementById("lastName").value &&
      document.getElementById("licenseNumber").value &&
      document.getElementById("specialty").value) {
      // Store user profile
      try {
        let responseBody = {
          first_name: document.getElementById("firstName").value,
          last_name: document.getElementById("lastName").value,
          email: preliminaryUserEmail,
          medical_license: document.getElementById("licenseNumber").value,
          specialty: document.getElementById("specialty").value,
        };
        const response = await fetch(`https://sixhats-backend.onrender.com/physician`, {
          method: "POST",
          body: JSON.stringify(responseBody),
          headers: {
            "Content-type": "application/json; charset=UTF-8"
          }
        });
        if (response.ok) {
          const responseData = await response.json();
          console.log(responseData)
          // Assuming a valid item has responses
          setshowCreateProfileModal(false)

          const response2 = await fetch(`https://sixhats-backend.onrender.com/physician/` + preliminaryUserEmail, {
            method: "get",
            headers: {
              "Content-type": "application/json; charset=UTF-8"
            }
          });

          const responseData2 = await response2.json();
          console.log(responseData2)
          const responsecategories = await fetch(`https://sixhats-backend.onrender.com/specialty/` + responseData2.specialty + `/prompt_categories`, {
            method: "get",
            headers: {
              "Content-type": "application/json; charset=UTF-8"
            }
          });

          const responseDataCategories = await responsecategories.json();
          localStorage.setItem("useremail", preliminaryUserEmail)
          setuserEmail(preliminaryUserEmail)
          localStorage.setItem("userid", responseData2.physician_id)
          setcategories(responseDataCategories.prompt_categories)
        } else {
          console.log("Did not succesfully create profile");
          return false;
        }
      } catch (error) {
        console.error('Error checking item:', error);
        return false;
      }
    } else {
      alert("Please fill out all fields")
    }
  }

  const endSession = function () {
    alert("Thank you for completing this process, your responses have been recorded")

    localStorage.removeItem("useremail")
    localStorage.removeItem("numcomplete")

    // reload the current page
    window.location.reload();
  }

  const handleUserRate = async function (event, rating) {
    event.preventDefault();

    let newItem = JSON.parse(JSON.stringify(item))

    let review = {
      review_outcome: rating,
      // All garbage for testing
      assignment_id: "123",
      reviewer_id: localStorage.getItem("userid"),
      review_order: item.review_assignments.length + 1,
      reviewed_at: null
    }
    let feedback = prompt(`Please describe why you rated this response as "${rating}"`)

    if (feedback === null) {
      // User clicked cancel
      return;
    }

    if (feedback)
      review.feedback = feedback
    else
      review.feedback = null
    
    newItem.review_assignments.push(review)

    let response = await fetch(`https://sixhats-backend.onrender.com/symptom_remedy_pair`, {
      method: "PUT",
      body: JSON.stringify(newItem),
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      }
    });
    let responseData = await response.json()
    console.log(responseData)

    if (item.review_assignments.length >= 1)
      alert(`The first reviewer rated this response\"${item.review_assignments[0].review_outcome}\" with the following explanation:\n ${item.review_assignments[0].feedback}`)

    let newNumCompleted = numCompleted + 1
    console.log(newNumCompleted)
    if (newNumCompleted < numCases) {
      localStorage.setItem("numcomplete", newNumCompleted)
      setnumCompleted(newNumCompleted)
      getNewCase()
    } else {
      endSession();
    }
  }

  const handleUserRateGood = async function (event) {
    handleUserRate(event, "good")
  }

  const handleUserRateBad = async function (event) {
    handleUserRate(event, "bad")
  }
  return (
    <>
      <div className='Navbar'>
        <h1 style={{ textAlign: "center" }}>6hats Case Study Evaluation</h1>
        <h4 style={{ textAlign: "center" }}>Please evaluate the case study below and indicate if you agree (up arrow) or disagree (down arrow)</h4>
        <hr />
      </div>

      {userEmail == null ? (<button className='begin-button' onClick={beginSession}>Begin Session</button>)
        :
        // If logged in, show case study
        <div>
          <div className='content-div' style={{ marginInline: "5%" }}>
            <div><p>Symptoms:</p> <p>{item ? item.symptom_description : ""}</p></div>
            <div><p>Response:</p> <p>{item ? item.remedy : ""}</p></div>
          </div>

          <p className="fixed-button lower-left-button">
            {numCompleted} / {numCases}
          </p>
          {/*<!-- Upward arrow button on the right side -->*/}
          <button className="fixed-button lower-mid-button" id="btn-query" onClick={handleUserRateGood}>
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
          <button className="fixed-button lower-button" id="btn-query" onClick={handleUserRateBad}>
            <FontAwesomeIcon icon={faArrowDown} />
          </button>
        </div>
      }

      <Modal show={showCreateProfileModal} onHide={() => setshowCreateProfileModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enter your information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", padding: "5px" }}>
            <p style={{ width: "20%" }}>Verification code:</p>
            <input id="codeCheck" style={{ marginRight: "10px", width: "80%" }} placeholder="Email verification not yet implemented"></input>
          </div>
          <div style={{ display: "flex", padding: "5px" }}>
            <p style={{ width: "20%" }}>First Name:</p>
            <input id="firstName" style={{ marginRight: "10px", width: "80%" }}></input>
          </div>
          <div style={{ display: "flex", padding: "5px" }}>
            <p style={{ width: "20%" }}>Last Name:</p>
            <input id="lastName" style={{ marginRight: "10px", width: "80%" }}></input>
          </div>
          <div style={{ display: "flex", padding: "5px" }}>
            <p style={{ width: "20%" }}>Medical License Number:</p>
            <input id="licenseNumber" style={{ marginRight: "10px", width: "80%" }}></input>
          </div>
          <div style={{ display: "flex", padding: "5px" }}>
            <p style={{ width: "20%" }}>Medical Specialty:</p>
            <input id="specialty" style={{ marginRight: "10px", width: "80%" }}></input>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={saveProfile} variant="primary">Ok</Button>
          <Button onClick={() => setshowCreateProfileModal(false)} variant="secondary">Cancel</Button>
        </Modal.Footer>
      </Modal >
    </>
  );
}

export default App;
